import type { SupportedLanguageCode } from "../language";

/**
 * Updates the path to reflect the specified language code.
 *
 * Expects path starting with /:languageCode?/map/
 * - Omits the languageCode if it is 'en'.
 * - Otherwise, ensures the path starts with /:languageCode/map.
 *
 * @param path - The path to update (e.g. "/de/map/foo/bar").
 * @param languageCode - The language code to apply.
 * @returns The updated path as a string.
 */
export function urlWithLanguageCode(
  path: string,
  languageCode: SupportedLanguageCode,
): string {
  // Remove any leading language code segment whether it's valid or not.
  const cleanPath = path.replace(/^\/[^/]{2}(?=\/map($|\/))/, "");
  if (languageCode === "en") {
    return cleanPath;
  } else {
    // Insert the language code after the leading slash
    return cleanPath.replace(/^\/map/, `/${languageCode}/map`);
  }
}
